import { IUserPreferences } from "../../EnterpriseGPTApi/EnterpriseGPTApiV1Client";

type SetUserPreferences = { type: 'SET_USER_PREFERENCES'; payload: IUserPreferences };

export type UserPreferencesAction = SetUserPreferences;

export const setUserPreferencesAction = (payload: IUserPreferences): SetUserPreferences => ({ type: 'SET_USER_PREFERENCES', payload });
